import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import API_BASE from './api/api';
import { Toaster } from "react-hot-toast";
import Home from './components/Home';
import Book from './components/Book'; 
import About from './components/About';
import Contact from './components/Contact';
import Login from './components/Login';
import Gallery from './components/Gallery';
import Cart from './components/Cart';
import Banner from './components/Banner';
import Hero from './components/Hero';
import Product from './components/Product';
import Addaddress from './components/Addaddress';
import Checkout from './components/Checkout';
import ResetPassword from './components/ResetPassword';
import Admin from './components/Admin';
import Dashboard from './components/Dashboard';
import Addbook from './components/Addbook';
import Viewbook from './components/Viewbook';
import User from './components/User';
import Order from './components/Order';
import ProtectedRoute from './components/protected'; 
import History from './components/History';
import Profile from './components/Profile';
import Pop from './components/Pop';
import Privacy from './components/Privacy';

import Whatsapp from './components/whatsapp';

import { updateActivity, clearSession } from './utils/session';

function ActivityWatcher() {
  useEffect(() => {
    const events = ["click", "mousemove", "keydown", "scroll"];
    events.forEach((e) =>
      window.addEventListener(e, () =>
        localStorage.setItem("last_activity_time", Date.now().toString())
      )
    );
  }, []);
  return null;
}

/* ✅ GLOBAL: Agar koi pending order localStorage mein ho toh
   user kisi bhi page pe aaye — save ho jaayega automatically */
function PendingOrderRecovery() {
  useEffect(() => {
    const raw = localStorage.getItem('pending_order');
    if (!raw) return;

    try {
      const pending = JSON.parse(raw);

      // Sirf tab retry karo jab payment_id aur order_id dono hoon
      if (!pending?.razorpay_payment_id || !pending?.razorpay_order_id) return;

      const attemptSave = async (retries = 5) => {
        try {
          const res = await axios.post(
            `${API_BASE}/save_order.php`,
            pending,
            { withCredentials: true }
          );
          if (res.data?.success || res.data?.message === 'Order already saved') {
            localStorage.removeItem('pending_order');
            console.log('[Recovery] Pending order saved successfully');
          } else if (retries > 0) {
            setTimeout(() => attemptSave(retries - 1), 4000);
          }
        } catch {
          if (retries > 0) setTimeout(() => attemptSave(retries - 1), 4000);
        }
      };

      attemptSave();
    } catch {
      localStorage.removeItem('pending_order'); // Corrupt data clear karo
    }
  }, []);

  return null;
}

function App() {
  return (
    <Router>
      <>
        <ActivityWatcher />
        <PendingOrderRecovery />
        <Whatsapp />
<Toaster
  position="bottom-center"
  gutter={12}
  toastOptions={{
    duration: 2500,
    style: {
      background: "#1f2937",
      color: "#fff",
      borderRadius: "12px",
      padding: "14px 18px",
      fontSize: "14px",
      fontWeight: "500",
      zIndex: 999999,
    },
    success: {
      style: {
        background: "#16a34a",
      },
    },
    error: {
      style: {
        background: "#dc2626",
      },
    },
  }}
/>
        <Routes>

          {/* Fix Google index.html */}
          <Route path="/index.html" element={<Navigate to="/" replace />} />

          {/* Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/book/:id" element={<Product />} />
          <Route path="/book" element={<Book />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route
  path="/reset-password/:token"
  element={<ResetPassword />}
/>
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/banner" element={<Banner />} />
          <Route path="/hero" element={<Hero />} />
          <Route path="/product" element={<Product />} />
          <Route path="/pop" element={<Pop />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Protected User Routes */}
          <Route path="/cart" element={
            <ProtectedRoute allowedRoles={['user']}>
              <Cart />
            </ProtectedRoute>
          } />
          <Route path="/addaddress" element={
            <ProtectedRoute allowedRoles={['user']}>
              <Addaddress />
            </ProtectedRoute>
          } />
          <Route path="/checkout" element={
            <ProtectedRoute allowedRoles={['user']}>
              <Checkout />
            </ProtectedRoute>
          } />
          <Route path="/order" element={
            <ProtectedRoute allowedRoles={['user']}>
              <Order />
            </ProtectedRoute>
          } />
          <Route path="/history" element={
            <ProtectedRoute allowedRoles={['user']}>
              <History />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute allowedRoles={['user']}>
              <Profile />
            </ProtectedRoute>
          } />

          {/* Protected Admin Dashboard */}
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Admin />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="addbook" element={<Addbook />} />
            <Route path="viewbook" element={<Viewbook />} />
            <Route path="user" element={<User />} />
            <Route path="order" element={<Order />} />
          </Route>

          {/* Catch-all fallback */}
          <Route path="*" element={<Home />} />

        </Routes>
      </>
    </Router>
  );
}

export default App;
